import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';
import './index.css';
import { useAuthStore } from './store/authStore.js';
import { useSessionStore } from './store/sessionStore.js';

// Capture beforeinstallprompt BEFORE React mounts — the event can fire
// very early and a component-level listener would miss it.
window.addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault();
  window.__installPrompt = e;
  window.dispatchEvent(new Event('installpromptready'));
});

if (import.meta.env.DEV) {
  window.__authStore = useAuthStore;
  window.__sessionStore = useSessionStore;
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
